import React from 'react';
import './styles/index.css';
import BanderaMalaga from '../../assets/BanderaMalaga.jpg';

// Usernames de los 6 jugadores clasificados para la Selección Malagueña
const CLASIFICADOS_MALAGA = [
  'Jmacias',
  'Paco Moreno', 
  'Morisco',
  'Tomiza',
  'Soler',
  'rocha',
];

/**
 * DashboardHeader - Componente reutilizable para el header de las páginas
 * 
 * Props:
 * - user: objeto con datos del usuario (username, nombre)
 * - subtitle: texto del subtítulo (ej: "Mis Ligas", "Campeonatos", "Panel de Jugador")
 * - loading: boolean para mostrar '---' en stats mientras carga
 * - promedioTotal: número del promedio global
 * - porcentajeVictorias: número del % de victorias
 * - onBack: función opcional para el botón volver
 * - onLogout: función para cerrar sesión
 * - showStats: boolean para mostrar/ocultar stats (default: true)
 */
const DashboardHeader = ({ 
  user, 
  subtitle = 'Panel',
  loading = false,
  promedioTotal = 0,
  porcentajeVictorias = 0,
  promedioOnline = null,
  porcentajeVictoriasOnline = null,
  onBack,
  onLogout,
  showStats = true
}) => {
  const username = user?.username || '';
  const isClasificado = CLASIFICADOS_MALAGA.includes(username);

  return (
    <>
      <div className={`dashboard-header dashboard-header-pro ${isClasificado ? 'dashboard-header-clasificado' : ''}`}>
        {/* Bandera de Málaga de fondo para clasificados */}
        {isClasificado && (
          <img src={BanderaMalaga} alt="" className="dashboard-header-bandera" />
        )}
        
        {/* Izquierda: Logo + Nombre */}
        <div className="header-brand">
          <img src="/Logo26.png" alt="501 Dart League" className="dashboard-logo" />
          <div className="header-brand-text">
            <h1>501 Dart League</h1>
            <span className="header-brand-subtitle">{subtitle}</span>
          </div>
        </div>
        
        {/* Derecha: Usuario + Stats + Acciones */}
        <div className="header-user-section">
          <div className="header-user-info">
            <span className="header-greeting">Hola, <strong>{user?.nombre || user?.username}</strong></span>
            {/* Stats compactos */}
            {showStats && (
              <div className="header-stats-inline">
                {promedioTotal > 0 && (
                  <span className="stat-pill">
                    <span className="stat-pill-label">Media</span>
                    <span className="stat-pill-value">
                      {loading ? '---' : promedioTotal.toFixed(1)}
                    </span>
                  </span>
                )}
                {promedioTotal > 0 && (
                  <span className="stat-pill">
                    <span className="stat-pill-label">Victorias</span>
                    <span className="stat-pill-value">
                      {loading ? '---' : `${porcentajeVictorias.toFixed(0)}%`}
                    </span>
                  </span>
                )}
                {promedioOnline != null && (
                  <span className="stat-pill stat-pill-online">
                    <span className="stat-pill-label">Media Online</span>
                    <span className="stat-pill-value">
                      {loading ? '---' : promedioOnline.toFixed(1)}
                    </span>
                  </span>
                )}
                {porcentajeVictoriasOnline != null && (
                  <span className="stat-pill stat-pill-online">
                    <span className="stat-pill-label">Vic. Online</span>
                    <span className="stat-pill-value">
                      {loading ? '---' : `${porcentajeVictoriasOnline.toFixed(0)}%`}
                    </span>
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="header-actions">
            {onBack && (
              <button onClick={onBack} className="btn-action btn-outline-action">
                ← Volver
              </button>
            )}
            {onLogout && (
              <button onClick={onLogout} className="btn-action btn-secondary-action">
                Cerrar sesión
              </button>
            )}
          </div>
        </div>
      </div>
      
      {/* Hitos para clasificados */}
      {isClasificado && (
        <div className="hitos-banner">
          <span className="hitos-icon">🏆</span>
          <span className="hitos-text">Clasificación Selección Malagueña 2026</span>
        </div>
      )}
    </>
  );
};

export default DashboardHeader;
